module.exports = __webpack_public_path__ + "welcome.jpg?6af534e98223777ba2cc0b68b8495f40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global/img/welcome.jpg
// module id = 23
// module chunks = 0